// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../elements/Modal/Modal';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import Loading from '../../../../../elements/Loading/Loading';

import style from './VerificationRemainderModal.scss';
import confirmMailImg from '../../../../../assets/img/YOGI-QEMPO2.png';

type Props = {
  +resendVerification: () => void;
  +isResending?: boolean;
  +isOpen: boolean;
  +handleClose: () => void;
};

const messages = defineMessages({
  text1: {
    id: 'modal.verificationReminder.text.part1',
  },
  text2: {
    id: 'modal.verificationReminder.text.part2',
  },
  text3: {
    id: 'modal.verificationReminder.text.part3',
  },
});

export default class VerificationRemainderModal extends Component<Props, void> {

  resendVerificationMail(e: Event) {
    e.preventDefault();
    const { resendVerification } = this.props;
    resendVerification();
  }

  render() {
    const { isResending, isOpen, handleClose } = this.props;
    return (
      <Modal key="verificationReminderModal"
             open={isOpen}
             width={544}
             height={408}
             handleClose={() => !isResending && handleClose()}>
        {isResending ? <Loading type="sk-three-bounce"
                                className={style.modalLoading}
                                number={3}/> :
          <section className={style.verificationRemainderModal}>
            <img src={confirmMailImg} alt="Yogi"/>
            <FormattedMessage id="modal.verificationReminder.title">{
              text => <h2>{text}</h2>
            }</FormattedMessage>
            <p>{this.context.intl.formatMessage(messages.text1)}</p>
            <p>{this.context.intl.formatMessage(messages.text2)}
              <a onClick={this.resendVerificationMail.bind(this)}>
                {` ${this.context.intl.formatMessage(messages.text3)}.`}
              </a>
            </p>
          </section>
        }
      </Modal>
    );
  }
}

VerificationRemainderModal.propTypes = {
  resendVerification: PropTypes.func.isRequired,
  isResending: PropTypes.bool,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};

VerificationRemainderModal.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/verification-remainder-modal/component/VerificationRemainderModal.jsx